import { render, staticRenderFns } from "./InspectionPicturesCard.vue?vue&type=template&id=61fab0b9&scoped=true&"
import script from "./InspectionPicturesCard.vue?vue&type=script&lang=js&"
export * from "./InspectionPicturesCard.vue?vue&type=script&lang=js&"
import style0 from "./InspectionPicturesCard.vue?vue&type=style&index=0&id=61fab0b9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fab0b9",
  null
  
)

export default component.exports